import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  PageAuthenticationPasswordResetComponent
} from "@account/_pages/authentication/password-reset/page-authentication-password-reset.component";
import {
  PageAuthenticationLoginComponent
} from "@account/_pages/authentication/login/page-authentication-login.component";
import {
  PageAuthenticationPasswordLostComponent
} from "@account/_pages/authentication/password-lost/page-authentication-password-lost.component";
import {AuthenticationsModule} from "@iw-shared/authentication/authentications.module";
import {LayoutModule} from "@iw-shared/layout/layout.module";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RouterLink} from "@angular/router";



@NgModule({
  declarations: [
    PageAuthenticationLoginComponent,
    PageAuthenticationPasswordResetComponent,
    PageAuthenticationPasswordLostComponent

  ],
  imports: [
    CommonModule,
    AuthenticationsModule,
    LayoutModule,
    FaIconComponent,
    RouterLink
  ]
})
export class PageAuthenticationModule {
}
